import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["width", "height"];
const _hoisted_2 = ["stroke"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", {
    width: $props.width,
    height: $props.height,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [_createElementVNode("path", {
    d: "M4.66536 7.99972L1.33203 9.66638L7.76018 12.8805C7.84764 12.9242 7.89137 12.9461 7.93723 12.9547C7.97785 12.9623 8.01954 12.9623 8.06016 12.9547C8.10603 12.9461 8.14976 12.9242 8.23721 12.8805L14.6654 9.66638L11.332 7.99972M1.33203 6.33305L7.76018 3.11897C7.84764 3.07525 7.89137 3.05338 7.93723 3.04478C7.97785 3.03716 8.01954 3.03716 8.06016 3.04478C8.10603 3.05338 8.14976 3.07525 8.23721 3.11897L14.6654 6.33305L8.23721 9.54713C8.14976 9.59085 8.10603 9.61272 8.06016 9.62132C8.01954 9.62895 7.97785 9.62895 7.93723 9.62132C7.89137 9.61272 7.84764 9.59085 7.76018 9.54713L1.33203 6.33305Z",
    stroke: $props.color,
    "stroke-width": "1.33",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, null, 8, _hoisted_2)], 8, _hoisted_1);
}